unit View.Contas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewContasList = class(TForm)
    btNew: TButton;
    ContasDataset: TXDataWebDataSet;
    ContasDatasetid: TIntegerField;
    ContasDatasetaliado_id: TIntegerField;
    ContasDatasetdata_base_id: TIntegerField;
    ContasDatasetbanco_id: TIntegerField;
    ContasDatasetnome: TStringField;
    ContasDatasettitular: TStringField;
    ContasDatasetabertura: TDateTimeField;
    ContasDatasetagencia_nome: TStringField;
    ContasDatasetagencia_numero: TStringField;
    ContasDatasetagencia_dv: TStringField;
    ContasDatasetconta_numero: TStringField;
    ContasDatasetconta_dv: TStringField;
    ContasDatasetdv_agencia_conta: TStringField;
    ContasDatasetcodigo_mestre: TStringField;
    ContasDatasetsaldo_abertura: TFloatField;
    ContasDatasetsaldo: TFloatField;
    ContasDatasetobs: TStringField;
    ContasDatasetcpf_cnpj: TStringField;
    ContasDatasetconta_bancaria: TBooleanField;
    ContasDatasetcodigo_interno: TIntegerField;
    ContasDatasetexcluido: TBooleanField;
    ContasDatasetinclusao: TDateTimeField;
    ContasDatasetalteracao: TDateTimeField;
    ContasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewContasList: TFViewContasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewContasList }

procedure TFViewContasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewContasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewContasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewContasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewContasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewContasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewContasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ContasDataset.Connection.Model.DefaultSchema.FindEntityType(ContasDataset.EntitySetName),
      ContasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewContasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('contas', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ContasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewContasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.contas.list.pagination.info');
  btNew := TButton.Create('view.contas.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.contas.list.table');
  cbPageSize := TComboBox.Create('view.contas.list.cbPageSize');
  edSearch := TEdit.Create('view.contas.list.search');
  lcPaginator := TListControl.Create('view.contas.list.pagination');
  ContasDataset := TXDataWebDataSet.Create(Self);
  ContasDatasetid := TIntegerField.Create(Self);
  ContasDatasetaliado_id := TIntegerField.Create(Self);
  ContasDatasetdata_base_id := TIntegerField.Create(Self);
  ContasDatasetbanco_id := TIntegerField.Create(Self);
  ContasDatasetnome := TStringField.Create(Self);
  ContasDatasettitular := TStringField.Create(Self);
  ContasDatasetabertura := TDateTimeField.Create(Self);
  ContasDatasetagencia_nome := TStringField.Create(Self);
  ContasDatasetagencia_numero := TStringField.Create(Self);
  ContasDatasetagencia_dv := TStringField.Create(Self);
  ContasDatasetconta_numero := TStringField.Create(Self);
  ContasDatasetconta_dv := TStringField.Create(Self);
  ContasDatasetdv_agencia_conta := TStringField.Create(Self);
  ContasDatasetcodigo_mestre := TStringField.Create(Self);
  ContasDatasetsaldo_abertura := TFloatField.Create(Self);
  ContasDatasetsaldo := TFloatField.Create(Self);
  ContasDatasetobs := TStringField.Create(Self);
  ContasDatasetcpf_cnpj := TStringField.Create(Self);
  ContasDatasetconta_bancaria := TBooleanField.Create(Self);
  ContasDatasetcodigo_interno := TIntegerField.Create(Self);
  ContasDatasetexcluido := TBooleanField.Create(Self);
  ContasDatasetinclusao := TDateTimeField.Create(Self);
  ContasDatasetalteracao := TDateTimeField.Create(Self);
  ContasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ContasDataset.BeforeLoadDFMValues;
  ContasDatasetid.BeforeLoadDFMValues;
  ContasDatasetaliado_id.BeforeLoadDFMValues;
  ContasDatasetdata_base_id.BeforeLoadDFMValues;
  ContasDatasetbanco_id.BeforeLoadDFMValues;
  ContasDatasetnome.BeforeLoadDFMValues;
  ContasDatasettitular.BeforeLoadDFMValues;
  ContasDatasetabertura.BeforeLoadDFMValues;
  ContasDatasetagencia_nome.BeforeLoadDFMValues;
  ContasDatasetagencia_numero.BeforeLoadDFMValues;
  ContasDatasetagencia_dv.BeforeLoadDFMValues;
  ContasDatasetconta_numero.BeforeLoadDFMValues;
  ContasDatasetconta_dv.BeforeLoadDFMValues;
  ContasDatasetdv_agencia_conta.BeforeLoadDFMValues;
  ContasDatasetcodigo_mestre.BeforeLoadDFMValues;
  ContasDatasetsaldo_abertura.BeforeLoadDFMValues;
  ContasDatasetsaldo.BeforeLoadDFMValues;
  ContasDatasetobs.BeforeLoadDFMValues;
  ContasDatasetcpf_cnpj.BeforeLoadDFMValues;
  ContasDatasetconta_bancaria.BeforeLoadDFMValues;
  ContasDatasetcodigo_interno.BeforeLoadDFMValues;
  ContasDatasetexcluido.BeforeLoadDFMValues;
  ContasDatasetinclusao.BeforeLoadDFMValues;
  ContasDatasetalteracao.BeforeLoadDFMValues;
  ContasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewContasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'banco_id';
      Title := 'banco_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'titular';
      Title := 'titular';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'abertura';
      Title := 'abertura';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'agencia_nome';
      Title := 'agencia_nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'agencia_numero';
      Title := 'agencia_numero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'agencia_dv';
      Title := 'agencia_dv';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_numero';
      Title := 'conta_numero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_dv';
      Title := 'conta_dv';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'dv_agencia_conta';
      Title := 'dv_agencia_conta';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_mestre';
      Title := 'codigo_mestre';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'saldo_abertura';
      Title := 'saldo_abertura';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'saldo';
      Title := 'saldo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'obs';
      Title := 'obs';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cpf_cnpj';
      Title := 'cpf_cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_bancaria';
      Title := 'conta_bancaria';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ContasDataset.SetParentComponent(Self);
    ContasDataset.Name := 'ContasDataset';
    ContasDataset.EntitySetName := 'Contas';
    ContasDataset.Connection := DMConnection.ApiConnection;
    ContasDataset.Left := 72;
    ContasDataset.Top := 144;
    ContasDatasetid.SetParentComponent(ContasDataset);
    ContasDatasetid.Name := 'ContasDatasetid';
    ContasDatasetid.FieldName := 'id';
    ContasDatasetid.Required := True;
    ContasDatasetaliado_id.SetParentComponent(ContasDataset);
    ContasDatasetaliado_id.Name := 'ContasDatasetaliado_id';
    ContasDatasetaliado_id.FieldName := 'aliado_id';
    ContasDatasetaliado_id.Required := True;
    ContasDatasetdata_base_id.SetParentComponent(ContasDataset);
    ContasDatasetdata_base_id.Name := 'ContasDatasetdata_base_id';
    ContasDatasetdata_base_id.FieldName := 'data_base_id';
    ContasDatasetdata_base_id.Required := True;
    ContasDatasetbanco_id.SetParentComponent(ContasDataset);
    ContasDatasetbanco_id.Name := 'ContasDatasetbanco_id';
    ContasDatasetbanco_id.FieldName := 'banco_id';
    ContasDatasetnome.SetParentComponent(ContasDataset);
    ContasDatasetnome.Name := 'ContasDatasetnome';
    ContasDatasetnome.FieldName := 'nome';
    ContasDatasetnome.Required := True;
    ContasDatasetnome.Size := 255;
    ContasDatasettitular.SetParentComponent(ContasDataset);
    ContasDatasettitular.Name := 'ContasDatasettitular';
    ContasDatasettitular.FieldName := 'titular';
    ContasDatasettitular.Size := 255;
    ContasDatasetabertura.SetParentComponent(ContasDataset);
    ContasDatasetabertura.Name := 'ContasDatasetabertura';
    ContasDatasetabertura.FieldName := 'abertura';
    ContasDatasetabertura.Required := True;
    ContasDatasetagencia_nome.SetParentComponent(ContasDataset);
    ContasDatasetagencia_nome.Name := 'ContasDatasetagencia_nome';
    ContasDatasetagencia_nome.FieldName := 'agencia_nome';
    ContasDatasetagencia_nome.Size := 255;
    ContasDatasetagencia_numero.SetParentComponent(ContasDataset);
    ContasDatasetagencia_numero.Name := 'ContasDatasetagencia_numero';
    ContasDatasetagencia_numero.FieldName := 'agencia_numero';
    ContasDatasetagencia_numero.Size := 255;
    ContasDatasetagencia_dv.SetParentComponent(ContasDataset);
    ContasDatasetagencia_dv.Name := 'ContasDatasetagencia_dv';
    ContasDatasetagencia_dv.FieldName := 'agencia_dv';
    ContasDatasetagencia_dv.Size := 255;
    ContasDatasetconta_numero.SetParentComponent(ContasDataset);
    ContasDatasetconta_numero.Name := 'ContasDatasetconta_numero';
    ContasDatasetconta_numero.FieldName := 'conta_numero';
    ContasDatasetconta_numero.Size := 255;
    ContasDatasetconta_dv.SetParentComponent(ContasDataset);
    ContasDatasetconta_dv.Name := 'ContasDatasetconta_dv';
    ContasDatasetconta_dv.FieldName := 'conta_dv';
    ContasDatasetconta_dv.Size := 255;
    ContasDatasetdv_agencia_conta.SetParentComponent(ContasDataset);
    ContasDatasetdv_agencia_conta.Name := 'ContasDatasetdv_agencia_conta';
    ContasDatasetdv_agencia_conta.FieldName := 'dv_agencia_conta';
    ContasDatasetdv_agencia_conta.Size := 255;
    ContasDatasetcodigo_mestre.SetParentComponent(ContasDataset);
    ContasDatasetcodigo_mestre.Name := 'ContasDatasetcodigo_mestre';
    ContasDatasetcodigo_mestre.FieldName := 'codigo_mestre';
    ContasDatasetcodigo_mestre.Size := 255;
    ContasDatasetsaldo_abertura.SetParentComponent(ContasDataset);
    ContasDatasetsaldo_abertura.Name := 'ContasDatasetsaldo_abertura';
    ContasDatasetsaldo_abertura.FieldName := 'saldo_abertura';
    ContasDatasetsaldo.SetParentComponent(ContasDataset);
    ContasDatasetsaldo.Name := 'ContasDatasetsaldo';
    ContasDatasetsaldo.FieldName := 'saldo';
    ContasDatasetsaldo.Required := True;
    ContasDatasetobs.SetParentComponent(ContasDataset);
    ContasDatasetobs.Name := 'ContasDatasetobs';
    ContasDatasetobs.FieldName := 'obs';
    ContasDatasetobs.Size := 255;
    ContasDatasetcpf_cnpj.SetParentComponent(ContasDataset);
    ContasDatasetcpf_cnpj.Name := 'ContasDatasetcpf_cnpj';
    ContasDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    ContasDatasetcpf_cnpj.Size := 255;
    ContasDatasetconta_bancaria.SetParentComponent(ContasDataset);
    ContasDatasetconta_bancaria.Name := 'ContasDatasetconta_bancaria';
    ContasDatasetconta_bancaria.FieldName := 'conta_bancaria';
    ContasDatasetconta_bancaria.Required := True;
    ContasDatasetcodigo_interno.SetParentComponent(ContasDataset);
    ContasDatasetcodigo_interno.Name := 'ContasDatasetcodigo_interno';
    ContasDatasetcodigo_interno.FieldName := 'codigo_interno';
    ContasDatasetcodigo_interno.Required := True;
    ContasDatasetexcluido.SetParentComponent(ContasDataset);
    ContasDatasetexcluido.Name := 'ContasDatasetexcluido';
    ContasDatasetexcluido.FieldName := 'excluido';
    ContasDatasetinclusao.SetParentComponent(ContasDataset);
    ContasDatasetinclusao.Name := 'ContasDatasetinclusao';
    ContasDatasetinclusao.FieldName := 'inclusao';
    ContasDatasetalteracao.SetParentComponent(ContasDataset);
    ContasDatasetalteracao.Name := 'ContasDatasetalteracao';
    ContasDatasetalteracao.FieldName := 'alteracao';
    ContasDatasetexclusao.SetParentComponent(ContasDataset);
    ContasDatasetexclusao.Name := 'ContasDatasetexclusao';
    ContasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ContasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ContasDataset.AfterLoadDFMValues;
    ContasDatasetid.AfterLoadDFMValues;
    ContasDatasetaliado_id.AfterLoadDFMValues;
    ContasDatasetdata_base_id.AfterLoadDFMValues;
    ContasDatasetbanco_id.AfterLoadDFMValues;
    ContasDatasetnome.AfterLoadDFMValues;
    ContasDatasettitular.AfterLoadDFMValues;
    ContasDatasetabertura.AfterLoadDFMValues;
    ContasDatasetagencia_nome.AfterLoadDFMValues;
    ContasDatasetagencia_numero.AfterLoadDFMValues;
    ContasDatasetagencia_dv.AfterLoadDFMValues;
    ContasDatasetconta_numero.AfterLoadDFMValues;
    ContasDatasetconta_dv.AfterLoadDFMValues;
    ContasDatasetdv_agencia_conta.AfterLoadDFMValues;
    ContasDatasetcodigo_mestre.AfterLoadDFMValues;
    ContasDatasetsaldo_abertura.AfterLoadDFMValues;
    ContasDatasetsaldo.AfterLoadDFMValues;
    ContasDatasetobs.AfterLoadDFMValues;
    ContasDatasetcpf_cnpj.AfterLoadDFMValues;
    ContasDatasetconta_bancaria.AfterLoadDFMValues;
    ContasDatasetcodigo_interno.AfterLoadDFMValues;
    ContasDatasetexcluido.AfterLoadDFMValues;
    ContasDatasetinclusao.AfterLoadDFMValues;
    ContasDatasetalteracao.AfterLoadDFMValues;
    ContasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
